import { Box, Stack, Text } from 'braid-design-system';
import { useTranslation } from 'react-i18next';

export type LoadingProps = {
    message?: string;
    size?: number;
};

export default function Loading({ message, size = 64 }: LoadingProps) {
    const { t } = useTranslation();
    const displayMessage = message ?? t('common.loading', { defaultValue: 'Loading...' });

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            width='full'
            height='full'
            style={{ background: 'rgba(255,255,255,0.6)', zIndex: 2 }}
        >
            <Box
                style={{ background: 'transparent' }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="full"
                height="full"
            >
                <Stack space="medium" align="center">
                    <Box
                        style={{
                            width: size,
                            height: size,
                            border: '6px solid #e0e7ff',
                            borderTop: '6px solid #6366f1',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                        }}
                    />
                    <Text weight="strong" size="large">
                        {displayMessage}
                    </Text>
                </Stack>
                <style>
                    {
                        `
                        @keyframes spin {
                            0% { transform: rotate(0deg);}
                            100% { transform: rotate(360deg);}
                        }
                        `
                    }
                </style>
            </Box>
        </Box>
    );
}